import { defaultBiopersistentes, defaultIarc, defaultMutagenicos, defaultNeurotoxicos, defaultOtotoxicos, defaultReprotoxicos, defaultSustanciasControladas, defaultTeratogenicos, defaultTlv } from "./state";
//funciones para biopersistentes

/**
 * recibe y muta para mostrar el listado de biopersistentes
 */
export function setbiopersistentes(state, biopersistentes) {
    biopersistentes.data.forEach(element => {
        element.tipo = 'Biopersistente'
    });

    state.biopersistentes = biopersistentes;
}
export function setBiopersistente(state, biopersistente) {
    state.selectedBiopersistente = biopersistente;
}
export function resetSelectedBiopersistente(state) {
    Object.assign(state.selectedBiopersistente, defaultBiopersistentes())
}
export function setPageBio(state, page) {
    state.params_bio.page = page
}


//funciones para IARC
export function setIarcs(state, iarcs) {
    iarcs.data.forEach(element => {
        element.tipo = 'Iarc'
    });
    state.iarcs = iarcs;
}
export function setIarc(state, iarc) {
    state.selectedIarc = iarc;
}

export function resetselectedIarc(state) {
    Object.assign(state.selectedIarc, defaultIarc())
}
export function setPageIarc(state, page) {
    state.params_iarc.page = page
}


// funciones mutagenicos
export function setMutagenicos(state, mutagenicos) {
    mutagenicos.data.forEach(element => {
        element.tipo = 'Mutagenicos'
    });
    state.mutagenicos = mutagenicos;
}
export function setMutagenico(state, mutagenico) {
    state.selectedMutagenico = mutagenico;
}

export function resetselectedMutagenico(state) {
    Object.assign(state.selectedMutagenico, defaultMutagenicos())
}
export function setPageMuta(state, page) {
    state.params_muta.page = page
}


// funciones para neurotoxicos

export function setNeurotoxicos(state, neurotoxicos) {
    neurotoxicos.data.forEach(element => {
        element.tipo = 'Neurotoxicos'
    });
    state.neurotoxicos = neurotoxicos;
}
export function setNeurotoxico(state, neurotoxico) {
    state.selectedNeurotoxico = neurotoxico;
}

export function resetselectedNeurotoxico(state) {
    Object.assign(state.selectedNeurotoxico, defaultNeurotoxicos())
}
export function setPageNeuro(state, page) {
    state.params_neuro.page = page
}

// funciones para ototoxicos
export function setOtotoxicos(state, ototoxicos) {
    ototoxicos.data.forEach(element => {
        element.tipo = 'Ototoxicos'
    });
    state.ototoxicos = ototoxicos;
}

export function setOtotoxico(state, ototoxico) {
    state.selectedOtotoxico = ototoxico;
}

export function resetselectedOtotoxico(state) {
    Object.assign(state.selectedOtotoxico, defaultOtotoxicos())
}
export function setPageOtoto(state, page) {
    state.params_ototo.page = page
}

// funciones para reprotoxicos
export function setReprotoxicos(state, reprotoxicos) {
    reprotoxicos.data.forEach(element => {
        element.tipo = 'Reprotoxicos'
    });
    state.reprotoxicos = reprotoxicos;
}
export function setReprotoxico(state, reprotoxico) {
    state.selectedReprotoxico = reprotoxico;
}

export function resetselectedReprotoxico(state) {
    Object.assign(state.selectedReprotoxico, defaultReprotoxicos())
}
export function setPageRepro(state, page) {
    state.params_repro.page = page
}

// funciones sustacias controladas
export function setSustanciasControladas(state, sustanciasControladas) {
    sustanciasControladas.data.forEach(element => {
        element.tipo = 'Sustancias_controladas'
    });
    state.sustanciasControladas = sustanciasControladas;
}
export function setSustanciaControlada(state, sustanciaControlada) {
    state.selectedSustanciaControlada = sustanciaControlada;
}

export function resetselectedSustanciaControlada(state) {
    Object.assign(state.selectedSustanciaControlada, defaultSustanciasControladas())
}
export function setPageSc(state, page) {
    state.params_sustancia.page = page
}


// funciones teratogenicos
export function setTerarogenicos(state, teratogenicos) {
    teratogenicos.data.forEach(element => {
        element.tipo = 'Teratogenicos'
    });
    state.teratogenicos = teratogenicos;
}
export function setTeratogenico(state, teratogenico) {
    state.selectedTeratogenico = teratogenico;
}
export function resetselectedTeratogenico(state) {
    Object.assign(state.selectedTeratogenico, defaultTeratogenicos())
}

export function setPageTerato(state, page) {
    state.params_terato.page = page
}

// funciones tlvs

export function setTlvs(state, tlvs) {
    tlvs.data.forEach(element => {
        element.tipo = 'Tlv'
    });
    state.tlvs = tlvs;
}
export function setTlv(state, tlv) {
    state.selectedTlv = tlv;
}
export function resetselectedTlv(state) {
    Object.assign(state.selectedTlv, defaultTlv())
}

export function setPageTlv(state, page) {
    state.params_tlv.page = page
}


// FUNCIONES PARA MANEJO DE COMPONENTES POR SUSTANCIA

export function setFiltroNocas(state, producto) {
    state.params_nocas.id_producto = producto
}

export function buscarSustancia(state, item) {
    state.filtro.nocas = item.nocas
    state.filtro.id_componente = item.id
}

/**
 * funcion para hacer la busqueda
 * @param {object} state
 * @param {string} buscar  parametro a buscar
 */
export function setFiltro(state, buscar) {
    if (buscar != state.params_caslistar.buscar) {
        state.params_bio.page = 1;
        state.params_iarc.page = 1;
        state.params_muta.page = 1;
        state.params_neuro.page = 1;
        state.params_ototo.page = 1;
        state.params_repro.page = 1;
        state.params_sustancia.page = 1;
        state.params_terato.page = 1;
        state.params_tlv.page = 1;
    }
    state.params_caslistar.buscar = buscar
    state.params_tlv.buscar = buscar
    state.params_iarc.buscar = buscar
    state.params_neuro.buscar = buscar
    state.params_ototo.buscar = buscar
    state.params_repro.buscar = buscar
    state.params_terato.buscar = buscar
    state.params_muta.buscar = buscar
    state.params_bio.buscar = buscar
    state.params_sustancia.buscar = buscar

}

/**
 * funcion para paginar
 * @param {object} state
 * @param {string} buscar  parametro a buscar
 */
 export function setPerPage(state, perPage) {

    state.params_caslistar.perPage = perPage
    state.params_tlv.perPage = perPage
    state.params_iarc.perPage = perPage
    state.params_neuro.perPage = perPage
    state.params_ototo.perPage = perPage
    state.params_repro.perPage = perPage
    state.params_terato.perPage = perPage
    state.params_muta.perPage = perPage
    state.params_bio.perPage = perPage
    state.params_sustancia.perPage = perPage

}

/**
 * limpia el filtro para buscar
 * @param {state} state
 */
export function resetFiltro(state) {
    state.params_caslistar.buscar = ""
    state.filtro.buscar = ""
    state.params_tlv.buscar = ""
    state.params_iarc.buscar = ""
    state.params_neuro.buscar = ""
    state.params_ototo.buscar = ""
    state.params_repro.buscar = ""
    state.params_terato.buscar = ""
    state.params_muta.buscar = ""
    state.params_bio.buscar = ""
    state.params_sustancia.buscar = ""

}


export function setCas(state, cas) {
    state.cas = cas.data
}
export function componentesCas(state, compo) {
    var comp = state.compo.find((i) => i.id_tab == compo.id && i.tipo == compo.tipo);
    if (!comp) {
        state.compo.push({
            id_tab: compo.id,
            nocas: compo.nocas,
            tipo: compo.tipo,
            porcentaje: '',
            sustancia: compo.sustancia_quimica,
        });
    }
}
export function eliminarComponentesCas(state, compo) {
    state.compo = state.compo.filter((i) => i.id_tab !== compo.id && i.tipo == compo.tipo);
}
/**
 * convierte el array de componentes en un objeto
 * @param {*} state
 * @param {*} componente
 */
export function setComponenteCas(state, componente) {
    state.arrayComponentes = Object.assign({}, componente);
}
/**
 * Convierte el array de sustancias en un objeto
 * @param {*} state
 * @param {*} componente
 */
export function setSustanciaCas(state, sustancia) {
    state.arrayCas = Object.assign({}, sustancia);
}

export function resetCas(state) {
    state.arrayCas = []
    state.compo = []
}

export function resetCompos(state) {
    state.compo = []
}

export function setComponente(state, componente) {
    state.componeCas = componente.data;
}

export function setListaCompo(state, select) {

    select.sustancias = state.compo
}

export function setSustancias(state, sustancias) {
    if (sustancias.data) {
        state.componeCas.map(c => {
            if (c.id === state.compoEditado.id) {
                c.sustancias = sustancias.data.sustancias
                state.compo = sustancias.data.sustancias
            }
        })
    }
}
export function componenteEditado(state, compo) {
    state.compoEditado = compo
}

export function editComponente(state, component) {
    state.selectedCas.id_tab = component.id_tab
    state.selectedCas.id_producto = component.id_producto
    state.selectedCas.id_componente = component.id_componente
    state.selectedCas.nocas = component.nocas
    state.selectedCas.componente = component.componente
    state.selectedCas.sustancia = component.sustancia
    state.selectedCas.tipo = component.tipo
    state.selectedCas.porcentaje = component.porcentaje
}
export function setAccion(state, accion) {
    state.accion = accion
}

/**
 * Método que carga la infromación de Cas de la empresa.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} data contiene la información de cas de la empresa.
 */
export function setCasEmpresa(state, data) {
    state.tlvs = [];
    state.iarcs = [];
    state.ototoxicos = [];
    state.neurotoxicos = [];
    state.sustanciasControladas = [];
    state.biopersistentes = [];
    state.reprotoxicos = [];
    state.mutagenicos = [];
    state.teratogenicos = [];

    state.tlvs = data.Cas.filter(i => i.tipo == 'Tlv')
    state.iarcs = data.Cas.filter(i => i.tipo == 'Iarc')
    state.sustanciasControladas = data.Cas.filter(i => i.tipo == 'Sustancias_controladas')
    state.neurotoxicos = data.Cas.filter(i => i.tipo == 'Neurotoxicos')
    state.ototoxicos = data.Cas.filter(i => i.tipo == 'Ototoxicos')
    state.biopersistentes = data.Cas.filter(i => i.tipo == 'Biopersistente')
    state.mutagenicos = data.Cas.filter(i => i.tipo == 'Mutagenicos')
    state.teratogenicos = data.Cas.filter(i => i.tipo == 'Teratogenicos')
    state.reprotoxicos = data.Cas.filter(i => i.tipo == 'Reprotoxicos')


}
